import React from "react";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
// import { useHistory } from "react-router-dom";
import axios from "axios";
import toastify from "../../Util/toastify";
import BaseURL from "../../Util/BaseURL";
const DeliveryReport = () => {
  // const history = useHistory();
  const location = useLocation();
  var nav = useNavigate();
  const [Trigger, setTrigger] = useState(false);
  const [orders, setOrders] = useState([""]);
  const [date, setDate] = useState();

  function navBack() {
    nav(-1);
  }
  const updateDispatch = async (props1, props2) => {
    axios.post(
      `${BaseURL}UpdateDispatch?id=${props1}&pid=${props2}`,
      {},
      { headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") } }
    );
    toastify("Product Dispatched", "success");
    nav(-1);
  };
  const getOrders = async () => {
    const r = await axios.get(
      `${BaseURL}getAllOrdersByNumber?number=${location.state.orderno}`,
      { headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") } }
    );
    setOrders(r.data[0]);
    setDate(r.data[0].date.substring(5, 17));
    setTrigger(true);
  };
  if (!Trigger) {
    getOrders();
  }
  return (
    <>
      <div className="modalBackground">
        <div className="modalContainer">
          <div className="title">
            <h1>Delivery Details</h1>
          </div>
          <div className="mainText">
            <div className="row modText">
              <p className="col">Name: {orders.username}</p>
              <p className="col">Email: vincent@sxcce.edu.in</p>
            </div>
            <div className="row modText">
              <p className="col ">Phone: {orders.phnumber}</p>
              <p className="col">Date: {date}</p>
            </div>
            <div className="row modText">
              <p className="col">Address: {orders.address}</p>
              <p className="col">Landmark: {orders.landmark}</p>
            </div>
            <div className="row modText">
              <p className="col ">Pin code: {orders.pincode}</p>
              <p className="col">Payment Method: {orders.payment}</p>
            </div>
          </div>
          <div className="footer">
            <button id="cancelBtn" onClick={() => navBack()}>
              Cancel
            </button>
            <button
              onClick={() =>
                updateDispatch(location.state.orderno, location.state.pid)
              }
            >
              Dispatch
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeliveryReport;
